module.exports = __webpack_public_path__ + "static/media/logoSport.bc7a6b46.svg";